<template>
  <section class="is-hidden-tablet"> 
   
    <!-- action wrap -->
    <div  :class="(filterScreen == 1 ? 'active' : '') + ' mobile-filter-actions-wrap default-mobile-actions'">
     <div class="mobile-filter-actions-manage">
       <div class="open-filter-modal-wrap">
         <a href="#" @click.prevent="changeScreen(2)" class="open-filter-modal"><i class="fas fa-angle-up"></i></a> 
       </div>
      
        <a class="button bg-secondary text-white" @click.prevent="changeScreen(1)">CANCEL</a>
        <!-- <a class="button bg-secondary text-white" @click.prevent="changeScreen(2)">SELECT FILTER</a> -->
     </div>
    </div>
    <!-- action wrap ends -->

    <!-- action with menu wrap -->
    <div :class="(filterScreen == 2 ? 'active' : '') + ' mobile-action-withmenu-options-wrap'">
      <div class="mobile-filters-wrap mobile-select-badge-filters py-10">
        <p class="has-text-weight-semibold mb20">Filters</p>
        <badges-filter-main :filters="filters"/>
      </div>
      <div class="mobile-filter-actions-wrap">
        <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
        <a class="button bg-secondary text-white" @click.prevent="changeScreen(1)">BACK</a>
          <a class="button bg-secondary text-white" @click.prevent="changeScreen(1)">APPLY</a>
        </div>
      </div>
    </div>
    <!-- action with menu wrap ends -->

  </section>
</template>

<script>
import { mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import BadgesFilterMain from '@/Components/Pages/User/Membership/BadgesFilterMain';

export default {
  components: {
    BadgesFilterMain,
  },
  props: {
    filters: {
      required: true,
      type: Object
    },
  },
  data() {
    return {
      filterScreen: 1,
    }
  },
  computed: {
   
  },

  mounted() {
    bus.$on('open-badge-flyout-filter', payload => {
      if(payload) {
        this.changeScreen(payload)
      }
    })
  },

  beforeDestroy() {
    bus.$off('open-badge-flyout-filter');
  },

  methods: {
    changeScreen(val) {
      this.filterScreen = val;
    },
    
    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  },
}
</script>
